import * as React from 'react';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useProductWithAFrameData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import { PrescriptionAvailabilityTag } from './PrescriptionAvailabilityTag.js';

const PrescriptionAvailabilityTagContainer = ()=>{
    const { product: { isOfferedWithPrescriptions  } ,  } = useProductWithAFrameData();
    if (!isOfferedWithPrescriptions) return null;
    return /*#__PURE__*/ React.createElement(PrescriptionAvailabilityTag, null);
};

export { PrescriptionAvailabilityTagContainer };
//# sourceMappingURL=PrescriptionAvailabilityTagContainer.js.map
